<template>
  <span v-if="self"> You </span>
  <v-tooltip v-else :disabled="absent" top open-delay="1000">
    <template v-slot:activator="{ on }">
      <span
        v-on="on"
        class="message-recipient pr-1"
        :class="{ 'message-recipient--absent': absent }"
        @click="$emit('select', identity)"
      >
        {{ name }}
      </span>
    </template>
    <span>See messages with {{ name }}</span>
  </v-tooltip>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'MessageRecipient',
  props: {
    name: String,
    identity: String,
    isAbsent: Function,
  },
  computed: {
    ...mapState('rooms', ['roomInfo']),
    absent() {
      return this.isAbsent(this.identity);
    },
    self() {
      return this.roomInfo?.identity === this.identity;
    },
  },
};
</script>
